import React from 'react';
import PropTypes from 'prop-types';
import {
    EMAIL_INVALID_MSG,
    FIELD_ERROR_CLASS,
    FIELD_STANDARD_CLASS,
} from '../../../helpers/messageText';

class FieldEmailAddress extends React.Component {
    renderClass = valid => {
        if (valid) {
            return FIELD_STANDARD_CLASS;
        } else {
            return FIELD_ERROR_CLASS;
        }
    };

    renderMessage = valid => {
        if (!valid) {
            return <div className="small form-control-feedback">{EMAIL_INVALID_MSG}</div>;
        }
    };

    render() {
        return (
            <div className={this.renderClass(this.props.fieldState)}>
                <label className="col-sm-2 form-control-label">Email</label>
                <div className="col-sm-10">
                    <div className="input-group">
                        <input
                            ref={input => (this.emailAddress = input)}
                            type="text"
                            name="emailAddress"
                            onChange={e => this.props.handleChange(e)}
                            className="form-control"
                            defaultValue={this.props.defaultValue}
                            placeholder=""
                            autoFocus
                        />
                    </div>
                    {this.renderMessage(this.props.fieldState)}
                </div>
            </div>
        );
    }
}

FieldEmailAddress.propTypes = {
    handleChange: PropTypes.func.isRequired,
    fieldState: PropTypes.bool.isRequired,
    defaultValue: PropTypes.string,
};

export default FieldEmailAddress;



// WEBPACK FOOTER //
// ./src/containers/_shared/Fields/EmailAddress.js